module.exports = __webpack_public_path__ + "img/image3.bdcf7c12.png";